<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown :popper-opts="popperOpt">
                <template slot="button-content">
                    <i class="famfamfam-silk cus-date"></i>
                    Appointments
                </template>
                <b-dropdown-item
                    href="#0"
                    v-if="_isExtensionEnabled(EXTENSIONS.CODE.CODE_BOARDING)"
                    @click="loadList(0)"
                >
                    <i class="famfamfam-silk cus-date"></i>View All Appointments
                    and Reservations
                </b-dropdown-item>

                <div
                    class="dropdown-divider"
                    v-if="_isExtensionEnabled(EXTENSIONS.CODE.CODE_BOARDING)"
                ></div>

                <b-dropdown-item href="#0" @click="loadList(1)">
                    <i class="famfamfam-silk cus-date"></i>View All Appointments
                </b-dropdown-item>
                <b-dropdown-item href="#0" @click="loadList(4)">
                    <i class="famfamfam-silk cus-date"></i>View Future
                    Appointments
                </b-dropdown-item>
                <b-dropdown-item href="#0" @click="loadList(5)">
                    <i class="famfamfam-silk cus-date"></i>View Past
                    Appointments
                </b-dropdown-item>
                <b-dropdown-item href="#0" @click="loadList(3)">
                    <i class="famfamfam-silk cus-date"></i>View Cancelled
                    Appointments
                </b-dropdown-item>

                <div
                    class="dropdown-divider"
                    v-if="_isExtensionEnabled(EXTENSIONS.CODE.CODE_BOARDING)"
                ></div>
                <b-dropdown-item
                    href="#0"
                    v-if="_isExtensionEnabled(EXTENSIONS.CODE.CODE_BOARDING)"
                    @click="loadList(2)"
                >
                    <i class="famfamfam-silk cus-date"></i>View All Reservations
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    v-if="_isExtensionEnabled(EXTENSIONS.CODE.CODE_BOARDING)"
                    @click="loadList(6)"
                >
                    <i class="famfamfam-silk cus-date"></i>View Future
                    Reservations
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    v-if="_isExtensionEnabled(EXTENSIONS.CODE.CODE_BOARDING)"
                    @click="loadList(7)"
                >
                    <i class="famfamfam-silk cus-date"></i>View Past
                    Reservations
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    v-if="_isExtensionEnabled(EXTENSIONS.CODE.CODE_BOARDING)"
                    @click="loadList(8)"
                >
                    <i class="famfamfam-silk cus-date"></i>View Cancelled
                    Reservations
                </b-dropdown-item>
                <div
                    class="dropdown-divider"
                    v-if="_hasAccess('schedule.appointment.create')"
                ></div>
                <b-dropdown-item
                    href="#0"
                    v-if="_hasAccess('schedule.appointment.create')"
                    @click.stop.prevent="$emit('create-appointment')"
                >
                    <i class="cus-add"></i>
                    New Appointment
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <list-appointments-reservations :key="componentKey" :code="code" />
        </b-card-text>
    </b-tab>
</template>
<script>
import EXTENSIONS from "@/constants/extensions";

export default {
    components: {
        ListAppointmentsReservations: () =>
            import("@/components/appointments/appointment-reservation-list")
    },
    data() {
        return {
            code: 0,
            componentKey: 0,
            EXTENSIONS,
            popperOpt: {
                placement: "bottom-start",
                modifiers: {
                    flip: {
                        enabled: false
                    }
                },
                positionFixed: true
            }
        };
    },
    computed: {},
    mounted() {},
    methods: {
        loadList(code) {
            this.code = code ? code : 0;
            this.componentKey += 1;
        }
    }
};
</script>
